import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
//Todo: fix a11y issues and update code to fix these lint errors
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import Icon from '@base/mlb-react-patterns/dist/components/Icon';

import Icon from './Icon';
import SubNav from './SubNav';
import { navAccessibility } from '../scripts/accessibility';
import { getWindowWidth, slugify, getDefaultIcon } from '../scripts/utils';
var TOP_NAV_HEIGHT_MLB = 56;
var TOP_NAV_HEIGHT_CLUB = TOP_NAV_HEIGHT_MLB * 2;
var NavItem = function NavItem(_ref) {
  var _classnames;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'nav-item' : _ref$className,
    closeMenu = _ref.closeMenu,
    collapseSubnav = _ref.collapseSubnav,
    isClub = _ref.isClub,
    isDefaultNav = _ref.isDefaultNav,
    isLoggedIn = _ref.isLoggedIn,
    navItem = _ref.navItem,
    navPosition = _ref.navPosition,
    navSideOpen = _ref.navSideOpen,
    setSideSubnav = _ref.setSideSubnav,
    setSpillOverNavItems = _ref.setSpillOverNavItems,
    subNavIndicator = _ref.subNavIndicator,
    locale = _ref.locale;
  var refNavItem = useRef();
  var topNavHeight = isClub ? TOP_NAV_HEIGHT_CLUB : TOP_NAV_HEIGHT_MLB;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDesktop = _useState4[0],
    setIsDesktop = _useState4[1];
  var isSideNav = navPosition === 'side';
  var hasSubnav = navItem.subnav && navItem.subnav.length ? true : undefined;
  var label = navItem.label,
    lang = navItem.lang,
    _navItem$shouldOpenIn = navItem.shouldOpenInNewWindow,
    shouldOpenInNewWindow = _navItem$shouldOpenIn === void 0 ? false : _navItem$shouldOpenIn,
    _navItem$url = navItem.url,
    url = _navItem$url === void 0 ? undefined : _navItem$url;
  var icon = getDefaultIcon(navItem.icon);
  var showDesktopIcon = navItem.showDesktopIcon;
  var appearanceDate = navItem.appears && navItem.appears * 1000;
  var expirationDate = navItem.expires && navItem.expires * 1000;
  // Timezones don't matter because time is given as unix timestamp
  var shouldAppear = appearanceDate ? Date.now() >= appearanceDate : true;
  var isItemExpired = expirationDate ? Date.now() >= expirationDate : false;
  var handleResize = useCallback(function () {
    var isDesktopLayout = getWindowWidth() >= 1024;
    setIsDesktop(isDesktopLayout);
    var currentNavItem = refNavItem.current;
    if (isDesktopLayout && currentNavItem && !navItem.isRevenueNav && currentNavItem.offsetTop >= topNavHeight && setSpillOverNavItems) {
      setSpillOverNavItems(function (prevState) {
        return Object.assign({}, prevState, _defineProperty({}, navItem.id, navItem.text));
      });
    }
  }, [navItem.id, navItem.isRevenueNav, navItem.text, setSpillOverNavItems, topNavHeight]);
  useEffect(function () {
    if (!isSideNav) {
      handleResize();
      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }
  }, [isLoggedIn, isSideNav, handleResize]);
  useEffect(function () {
    if (isSideNav && collapseSubnav) {
      setIsExpanded(false);
    }
  }, [collapseSubnav, isSideNav, navItem.text]);
  var repositionTopnavSubnav = function repositionTopnavSubnav() {
    var domEl = refNavItem.current;
    if (domEl && domEl.className.indexOf('header__nav-top__nav-item--parent') > -1) {
      var windowWidth = getWindowWidth();
      var subNav = domEl.querySelector('.header__subnav');
      var subNavNaturalRight = subNav.getBoundingClientRect().right;
      if (windowWidth > 1024 && windowWidth < subNavNaturalRight) {
        subNav.classList.add('header__subnav--pin-to-right');
      }
    }
  };
  useEffect(function () {
    if (isExpanded && !isSideNav) {
      repositionTopnavSubnav();
    }
  }, [isExpanded, isSideNav]);
  var populateDefaultSubnav = useCallback(function (isNavSideOpen) {
    if (isNavSideOpen) {
      if (isDefaultNav) {
        setIsExpanded(true);
        setSideSubnav({
          subNavData: navItem.subnav,
          locale: locale,
          parentNavItem: navItem,
          navPosition: navPosition
        });
      }
    } else if (setIsExpanded) {
      setIsExpanded(false);
    }
  }, [isDefaultNav, locale, navItem, navPosition, setSideSubnav]);
  useEffect(function () {
    if (isSideNav) {
      populateDefaultSubnav(navSideOpen);
    }
  }, [navSideOpen, isSideNav, populateDefaultSubnav]);
  var handleActive = function handleActive() {
    var domEl = refNavItem.current;
    var isParentNav = domEl.className.indexOf('__nav-item--parent') > -1;
    if (isParentNav & !isExpanded) {
      setIsExpanded(true);
      if (isSideNav) {
        setSideSubnav({
          subNavData: navItem.subnav,
          locale: locale,
          parentNavItem: navItem,
          navPosition: navPosition
        });
      }
    }
  };
  var handleInactive = function handleInactive() {
    if (!isSideNav) {
      setIsExpanded(false);
    }
  };

  // Added for VoiceOver double taps on mobile devices
  var onClickHandler = function onClickHandler() {
    if (isExpanded) {
      handleInactive();
    } else {
      handleActive();
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    return navAccessibility({
      closeMenu: closeMenu,
      event: event,
      hasSubnav: hasSubnav,
      handleActive: handleActive,
      isExpanded: isExpanded,
      setIsExpanded: setIsExpanded,
      navPosition: navPosition,
      navSideOpen: navSideOpen,
      refNavItem: refNavItem,
      isDefaultNav: isDefaultNav
    });
  };
  var handleClick = function handleClick(e) {
    if (shouldOpenInNewWindow) {
      window.open(url);
      e.preventDefault();
    }
  };
  var navItemClasses = classnames((_classnames = {}, _defineProperty(_classnames, className, true), _defineProperty(_classnames, "".concat(className, "--spotlight"), navItem.isSpotlight), _defineProperty(_classnames, "".concat(className, "--mobile-quick-nav"), navItem.isMobileNav), _defineProperty(_classnames, "".concat(className, "--mobile-quick-nav--hideRevenue"), navItem.isRevenueNav), _defineProperty(_classnames, "".concat(className, "--parent"), hasSubnav), _defineProperty(_classnames, "".concat(className, "--current"), navItem.isCurrentSection), _defineProperty(_classnames, "default", isDefaultNav), _classnames));

  //set aria-haspop and aria-expanded eligibility to items not in the mobile quicknav
  var ariaExpandable = hasSubnav && !(!isSideNav && !isDesktop);
  return !navItem.isHidden && !isItemExpired && shouldAppear && /*#__PURE__*/React.createElement("li", {
    ref: refNavItem,
    key: "".concat(navItem.text, "-navItem"),
    className: navItemClasses,
    onClick: onClickHandler,
    onMouseEnter: handleActive,
    onMouseLeave: handleInactive,
    onKeyDown: handleKeyDown,
    tabIndex: 0 // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
    ,
    "data-nav-id": "nav-".concat(navPosition || 'top', "-item-").concat(slugify(navItem.text)),
    "aria-haspopup": ariaExpandable,
    "aria-expanded": ariaExpandable ? isExpanded : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, "--inner")
  }, isSideNav && hasSubnav || navItem.text === 'MORE' || url === '' ? /*#__PURE__*/React.createElement("a", {
    href: url,
    className: "".concat(className, "__link"),
    "aria-haspopup": ariaExpandable,
    hrefLang: lang,
    lang: lang,
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    tabIndex: -1
  }, icon && (isSideNav || showDesktopIcon) && /*#__PURE__*/React.createElement(Icon, {
    className: "icon__nav-item",
    icon: icon
  }), /*#__PURE__*/React.createElement("span", {
    "aria-haspopup": ariaExpandable,
    "aria-hidden": !!label,
    className: "".concat(className, "__text")
  }, navItem.text === 'MORE' ? /*#__PURE__*/React.createElement(Icon, {
    className: "icon__spill-over",
    icon: "more-options"
  }) : navItem.text), subNavIndicator && hasSubnav && /*#__PURE__*/React.createElement("span", {
    className: "".concat(className, "__subnav-arrow")
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon__subnav-arrow",
    icon: "caret-down"
  }))) : /*#__PURE__*/React.createElement("a", {
    href: url,
    "aria-haspopup": false,
    className: "".concat(className, "__link"),
    hrefLang: lang,
    lang: lang,
    onClick: handleClick,
    tabIndex: -1
  }, icon && (isSideNav || showDesktopIcon) && /*#__PURE__*/React.createElement(Icon, {
    className: "icon__nav-item",
    icon: icon
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(className, "__text"),
    "aria-hidden": !!label
  }, navItem.text))), !isSideNav && hasSubnav && /*#__PURE__*/React.createElement(SubNav, {
    subNavData: navItem.subnav,
    locale: locale,
    parentNavItem: navItem,
    navPosition: navPosition
  }));
};
export default NavItem;
NavItem.propTypes = {
  className: PropTypes.string,
  closeMenu: PropTypes.func,
  collapseSubnav: PropTypes.bool,
  isClub: PropTypes.bool,
  isDefaultNav: PropTypes.oneOf([true, undefined]),
  isLoggedIn: PropTypes.bool,
  locale: PropTypes.string,
  navItem: PropTypes.shape({
    appears: PropTypes.string,
    expires: PropTypes.string,
    hreflang: PropTypes.string,
    icon: PropTypes.string,
    id: PropTypes.string,
    isCurrentSection: PropTypes.bool,
    isHidden: PropTypes.bool,
    isMobileNav: PropTypes.bool,
    isSpotlight: PropTypes.bool,
    label: PropTypes.string,
    lang: PropTypes.string,
    shouldOpenInNewWindow: PropTypes.bool,
    showDesktopIcon: PropTypes.bool,
    subnav: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
    text: PropTypes.string,
    url: PropTypes.string,
    isRevenueNav: PropTypes.bool
  }).isRequired,
  navPosition: PropTypes.string,
  navSideOpen: PropTypes.bool,
  setSideSubnav: PropTypes.func,
  setSpillOverNavItems: PropTypes.func,
  subNavIndicator: PropTypes.string
};
NavItem.defaultProps = {
  className: '',
  subNavIndicator: '',
  navSideOpen: false
};